import React from 'react';
import './styles.css';
import Views from "./components/views";

const MenuItems = () => {

  return <Views/>;
};

export default MenuItems;